module.exports = __webpack_public_path__ + "static/media/lineto-circular-book.2ac8bef0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/lineto-circular-book.woff
// module id = 1596
// module chunks = 27